import withInputErrorMessage from '../withInputErrorMessage';
import withOptionsSelectValueInitById from './withOptionsSelectValueInitById';
import withFormikSelect from './withSelectFormik';

const currentYear = (new Date()).getFullYear();
const options = Array(14).fill(undefined).map((v, i) => {
   const year = `${ +currentYear + i }`;
   return ({
      value: year,
      label: year,
      id: year,
   });
});

export default withFormikSelect(withInputErrorMessage(withOptionsSelectValueInitById(options)));
